import React, { useContext } from "react"
import { ManifestsPage as SharedManifestsPage } from "@stjeans/shared-frontend/manifests"
import AppContext from "../../AppContext.jsx"
import api from "../../api.js"
import { formatManifestStatus, manifestStatusColor } from "../../helpers.js"

export default function ManifestsPage() {
  const { app } = useContext(AppContext)

  return (
    <SharedManifestsPage
      app={app}
      api={api}
      helpers={{ formatStatus: formatManifestStatus, manifestStatusColor }}
      showAllLocationsBadge={false}
      showImportLodgeManifestWorkflow={false}
      showCurrentYearFilter={true}
      columns={[
        { key: "manifestNumber", label: "Manifest #", preferredWidth: 140, cellType: "text", value: (m) => m.manifestNumber, cellClassName: "fw-semibold", cellStyle: { color: "#0f6170" } },
        { key: "numOrders", label: "# Orders", preferredWidth: 95, cellType: "text", value: (m) => String(m.numOrders ?? "") },
        { key: "createdDate", label: "Created Date", preferredWidth: 130, cellType: "text", value: (m) => m.createdDate },
        { key: "closedDate", label: "Closed Date", preferredWidth: 130, cellType: "text", value: (m) => m.closedDate },
        { key: "shippedDate", label: "Shipped Date", preferredWidth: 130, cellType: "text", value: (m) => m.shippedDate },
        { key: "status", label: "Status", preferredWidth: 140, minWidth: 130, cellType: "status", value: (m) => m.status },
      ]}
    />
  )
}

